/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespIconBubbles_item$ref = any;
type PdpRespTradeIconBubbles_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespIconBubblesWrapper_item$ref: FragmentReference;
export type PdpRespIconBubblesWrapper_item = {|
  +$fragmentRefs: PdpRespIconBubbles_item$ref & PdpRespTradeIconBubbles_item$ref,
  +$refType: PdpRespIconBubblesWrapper_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespIconBubblesWrapper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_item",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f772fc672a6929d8b888ed1950bbfa1e';
module.exports = node;
